<bdeo-drawer #drawer closable overlay [headerTitle]="'send_report.title' | i18nextEager">
  <p class="description">
    {{ 'send_report.subtitle' | i18nextEager }}
  </p>
  <section class="form" [formGroup]="sendReportForm">
    <email-chip-input formControlName="emails" ngDefaultControl></email-chip-input>
    <div>
      <bdeo-textarea
        type="form"
        size="large"
        placeholder="{{ 'send_report.comments_placeholder' | i18nextEager }}"
        height="max"
        ngDefaultControl
        formControlName="comments"
      >
      </bdeo-textarea>
    </div>
  </section>
  <app-footer selectorForPadding=".add-wrapper">
    <bdeo-button
      type="primary"
      [icon]="loading ? 'loading-circle' : 'action-send-outline'"
      [text]="'actions.send_report' | i18nextEager"
      [disabled]="!sendReportForm.valid || loading"
      (click)="send()"
    ></bdeo-button>
    <bdeo-button type="secondary" skin="ghost" text="Candelar" [disabled]="loading" (click)="close()"></bdeo-button>
  </app-footer>
</bdeo-drawer>
